import React from 'react'
import StreamingDashboard from './components/StreamingDashboard'

function App() {
  return <StreamingDashboard />
}

export default App
